import React, {useState, useEffect, useContext} from 'react'
import { CSVLink }                              from "react-csv";
import { capitalizeWords }                      from 'functions/functions';
import { ToastContainer, toast }                from 'react-toastify';
import { getAllKeyLoanData,}                    from '../services/keyServices'
import DataTable                                from "react-data-table-component";
import DataTableSkeleton                        from 'components/skeleton/dataTableSkeleton';
import DashboardLayout                          from '../layouts/dashboardLayout'
import UserContext                              from '../contexts/userContext'
import BasicInput                               from 'components/inputs/basicInput';
import BasicThemeButton                         from 'components/buttons/basicThemeButton';
import moment from "moment";
import location_icon                            from '../images/location-pin.png';
import { doc, getDoc } from 'firebase/firestore';
import { db } from 'firebaseConfig';
import { showErrorToast } from 'utils/toasts';

function KeyLoanHistoryScreen() {

  const [data, setData] = useState([]);
  const [searchValue, setSearchValue] = useState('');
  const [loading, setLoading] = useState(false);

  const {user} = useContext(UserContext);

  const header = [
    {label : "Visitor Name",  key : 'visitorName'},
    {label : "Company",       key : 'visitorCompany'},
    {label : "Email",         key : 'visitorEmail'},
    {label : "Phone No.",     key : 'visitorPhone'},
    {label : "Tag Name",      key : 'tag'},
    {label : "Key No.",       key : 'keyNumber'},
    {label : "Issue Time",    key : 'issueTime'},
    {label : "Return Time",   key : 'returnTime'},
  ];

const columns = [
    {name: 'Name', selector: row => capitalizeWords(row.visitorName)},
    {name : "Company", selector : row => capitalizeWords(row.visitorCompany)},
    {name : "Tag Name", selector : row => capitalizeWords(row.tag)},
    {name : "Key No.", selector : row => row.keyNumber},
    {name : "Email", selector : row => row.visitorEmail},
    {name : "Phone No.", selector : row => row.visitorPhone},
    {name : "Issue Time", selector : row => moment(row.issueTime, "MM/DD/YYYY hh:mm A").format("MMM DD YYYY hh:mm A")},
    {name : "Return Time", selector : row => moment(row.returnTime, "MM/DD/YYYY hh:mm A").format("MMM DD YYYY hh:mm A")},
    {name : "Location", button : true, cell : (row) => (
      <img className='location-pin' src={location_icon} onClick={()=> onLocationClick(row.location)} />
    )}
  ];

  const onLocationClick = (location) => {
    if(location[0] && location[1]) window.open(`https://maps.google.com?q=${location[0]},${location[1]}`, '_blank', 'noreferrer');
    else toast.error("No Location Details");
  }

  useEffect(() => {
    fethData();
    // getAllKeyLoanData(user.buildingId).then((res) => {
    //   setData(res.result);
    //   setTimeout(() => {
    //     setLoading(false);
    //   }, 500);
    // })
  }, []);

  const fethData = async () => {
    setLoading(true);
    const email = await getAccountEmail();
    const [retentionPeriod, keyData] = await Promise.all([getRetentionPeriod(email), getAllKeyLoanData(user.buildingId)]);
    let filteredKeyData = [];

    if (retentionPeriod !== 'na') {
      keyData.result.forEach((key) => {
        const returnTime = new Date(key.returnTime); // Ensure it's a Date object
        const currentDate = new Date();
        
        // Check if returnTime is valid
        if (isNaN(returnTime.getTime())) {
          console.error("Invalid date format:", key.returnTime);
          return; // Skip invalid dates
        }
    
        // Calculate the difference in days
        const differenceInTime = currentDate.getTime() - returnTime.getTime();
        const differenceInDays = Math.round(differenceInTime / (1000 * 60 * 60 * 24));
    
        if(differenceInDays <= retentionPeriod) {
          filteredKeyData.push(key)
        }
      });
    } else {
      filteredKeyData = keyData.result;
    }
    setData(filteredKeyData);
    setLoading(false);


  }


  // Function to get email address of the main account
  const getAccountEmail = async () => {
    const managerId = user.manager;

    try {
      const userRef = doc(db, "users", managerId);
      const userSnap = await getDoc(userRef);
      if(userSnap.exists()) {
        const accountEmail = userSnap.data().email;
        return accountEmail;
      }
    } catch(err) {
      showErrorToast('Something Went Wrong');
    }
  }

  const getRetentionPeriod = async (email) => {
    try {
      const accountRef = doc(db, "account", email);
      const accountSnap = await getDoc(accountRef);
      if(accountSnap.exists()) {
        const retentionPeriod = accountSnap?.data()?.dataRetentionPeriod ?? '';
        if(retentionPeriod) {
          return retentionPeriod;
        } else return 'na';
      }
    } catch(err) {
      showErrorToast('Something Went Wrong');
    }
  }

  const onSearchValueChanges = (e) => {
    setSearchValue(e.target.value.toLowerCase());
  }

  return (
    <DashboardLayout pageTitle="Key Loan History">
        <div className="row gap-1">
            <BasicInput  placeholder="Search by Visitor Name or Key Tag" value={searchValue} setValue={setSearchValue} onChange={onSearchValueChanges} />
            <div className="export-data">
              <CSVLink data={data} headers={header} filename="Key_Loan_History.csv">
                <BasicThemeButton title="Export to CSV" />
              </CSVLink>
            </div>
        </div>
        <div className="table-container">
          {loading ?
            <DataTableSkeleton /> :
            <DataTable 
              columns={columns}
              data={data.filter(item => {
                if(searchValue == '') return item
                if(item.visitorName.toLowerCase().includes(searchValue.toLocaleLowerCase()) || item.tag.toLowerCase().includes(searchValue.toLowerCase())) return item
              })}
              highlightOnHover
              pagination
              paginationPerPage={10}
              paginationRowsPerPageOptions={[3, 5, 10, 15, 20]}
              paginationComponentOptions={{
                rowsPerPageText: "Records per page:",
                rangeSeparatorText: "out of"
              }}
            /> 
          }
        </div>
    </DashboardLayout>
  )
}

export default KeyLoanHistoryScreen;